













import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Price extends Vue {
    @Prop({ required: true }) price!: number;

    @Prop() purpose!: number;

    @Prop({ default: true }) displayPrice!: boolean;

    @Prop() currency!: string;

    @Prop({ default: false }) makeOffer!: boolean;

    @Prop({ default: "text-14 text-white bg-brand px-12 py-4" }) labelClass!: string;

    get computedPrice() {
        let symbol: string = this.currency;
        const price: string = `${this.price}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        if (this.purpose === 1) {
            return `${symbol} ${price}`;
        } else if (this.purpose === 2) {
            return `${symbol} ${price} / maand`;
        } else if (this.purpose === 5) {
            return `In optie`;
        }

        return "";
    }
}
